// extracted by mini-css-extract-plugin
module.exports = {"embla":"slider_embla__zTuyc","emblaContainer":"slider_emblaContainer__cNcea","emblaSlide":"slider_emblaSlide__t_Jvc","current":"slider_current__mHnRO"};